'use client'

import { Cell, Image, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import type { Slide, ABTestConfig } from '../newContentTestConfig'
import { BulletPointList } from '../BulletPointList'

type Props = {
  slide: Slide
  config: ABTestConfig
}

export const IntroSlide = ({ slide, config }: Props) => {
  const translate = useTranslate('conversation.phishing_first_time_lister_education')
  const asset = useAsset('/assets/phishing-first-time-lister-education')
  const titleAlignment = slide.bulletPoints ? 'left' : 'center'

  return (
    <Cell>
      {config.showIntroSpacer && <Spacer size="x3-large" />}
      <div className="u-flexbox">
        <Image
          src={asset(slide.image, { theme: { dark: `dark/${slide.image}` } })}
          size="x3-large"
          alt={translate(slide.title)}
          scaling="contain"
        />
      </div>
      <Spacer size="large" />
      <Text
        as="h1"
        text={translate(slide.title)}
        type={config.titleType}
        alignment={titleAlignment}
        width="parent"
      />
      <Spacer size="large" />
      <Text as="span" text={translate(slide.body)} type="body" alignment="left" html />
      {slide.bulletPoints && <BulletPointList bulletPoints={slide.bulletPoints} />}
    </Cell>
  )
}
